import { createFeatureSelector, createSelector } from '@ngrx/store';

import { AvailableOffersState } from './available-offers.state';

export const selectAvailableOffersState =
  createFeatureSelector<AvailableOffersState>('availableOffers');

export const selectMsisdnsByVariation = createSelector(
  selectAvailableOffersState,
  (state: AvailableOffersState) => state.msisdnsByVariation
);

export const selectAvailableOffersLoading = createSelector(
  selectAvailableOffersState,
  (state: AvailableOffersState) => state.loading
);

export const selectAvailableOffersError = createSelector(
  selectAvailableOffersState,
  (state: AvailableOffersState) => state.error
);

// Selector para buscar MSISDNs de uma variation específica
export const selectMsisdnsByVariationUuid = (variationUuid: string) =>
  createSelector(
    selectMsisdnsByVariation,
    msisdnsByVariation => msisdnsByVariation[variationUuid] || []
  );

// Verificar se há msisdns disponíveis (available-offers não está vazio)
export const selectHasAvailableMsisdns = createSelector(
  selectAvailableOffersState,
  (state: AvailableOffersState) => {
    const hasMappedMsisdns = Object.values(state.msisdnsByVariation).some(msisdns => msisdns && msisdns.length > 0);
    
    if (!hasMappedMsisdns && state.rawResponse?.avaliableMsisdnsForOffers) {
      return Object.values(state.rawResponse.avaliableMsisdnsForOffers).some(msisdns => msisdns && msisdns.length > 0);
    }
    
    return hasMappedMsisdns;
  }
);
